import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';

const SlideIn = ({ children }) => {
  const [ref, inView] = useInView();
  const slideIn = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(50%)',
  });

  return (
    <animated.div ref={ref} style={slideIn}>
      {children}
    </animated.div>
  );
};

export default SlideIn;
